import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Capacitor } from '@capacitor/core';
import { ModalController, NavController } from '@ionic/angular/standalone';
import { AuthComponent } from '../components/auth/auth.component';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  api = inject(ApiService)
  constructor(
    private readonly router: Router,
    private modalController: ModalController,
    private navController: NavController
  ) {}

  public async canActivate() {
    const cu = await FirebaseAuthentication.getCurrentUser()
    if(cu.user) {
      return true
    } 

    console.log("AuthGuard no user")
    if(Capacitor.isNativePlatform()) {
      //this.router.navigate(["auth"])
      console.log("AuthGuard presenting modal")

      const modal = await this.modalController.create({
        component: AuthComponent
      })

      await modal.present()
      const {data} = await modal.onDidDismiss()
      if(data && data.home) {
        return true
      }
    } else {
      this.navController.navigateRoot("/appstore")
    }
    
    return false
  }
}